import { EVENT_NAME as ADD_TO_WEB_PROJECT_EVENT } from '@adobe-fonts/site/events/AddToWebProjectEvent.js';
import { getService } from '../../../util/angular_helpers.js';

export class VariationCardAddToWebProject {
  constructor(element) {
    this.element = element;
  }

  handleAddToWebProjectEvent = (event) => {
    const card = event.target.closest('[data-slug]');
    if (!card || !('slug' in card.dataset)) {
      return;
    }

    this.authenticateAddToWebProject(card.dataset.slug, card.dataset.variationSlug);
  };

  authenticateAddToWebProject(familySlug, variationSlug) {
    const addToWebProjectService = getService('AddFontsToWebProjectService');
    return addToWebProjectService.addFamilyToWebProjectWithAuthentication(familySlug, variationSlug);
  }
}

export function registerEventHandlers(element) {
  const variationAddToWebProject = new VariationCardAddToWebProject(element);
  element.addEventListener(ADD_TO_WEB_PROJECT_EVENT, variationAddToWebProject.handleAddToWebProjectEvent);
}
